import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import Toolbar from "components/Admin/ClientUrls/Toolbar";
import { ClientUrlsList } from "components/Admin/ClientUrls/List/ClientUrlsList";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

const {
  showDeleteClientUrlsConfirmationModal,
  loadClientUrlsSagaAdmin,
} = actions;

class ClientUrls extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.timer = true;
    this.state = {
      client_urls_ids: [],
      page: props.page || 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
        ...props.query,
      },
      startDate: null,
      endDate: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.total_pages != this.props.total_pages)
      this.setState({
        page: 1,
      });
  }

  componentWillMount = () => {
    this.updateList();
  };

  deleteClientUrls = () => {
    if (this.state.client_urls_ids.length > 0)
      this.props.deleteClientUrls(this.state.client_urls_ids);
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.updateList
    );
  };

  onOrderChange = (field = "name", order = "desc") => {
    console.log(field, order);
    // const searchQuery = {
    //   ...this.state.searchQuery,
    //   [field]: order,
    // };
    // this.setState(
    //   {
    //     searchQuery,
    //   },
    //   this.updateList
    // );
  };

  checkedClientUrlIds = (client_url_id) => {
    var ids = _.assign(this.state.client_urls_ids),
      index = this.state.client_urls_ids.indexOf(client_url_id);

    if (index == -1) {
      ids.push(client_url_id);
    } else {
      ids.splice(index, 1);
    }
    this.setState({ client_urls_ids: ids });
  };

  changeFilterQuery = (field, value) => {
    const query = { ...this.state.searchQuery, ...{ [field]: value } };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateList, 500);
    });
  };

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.searchQuery,
      ...{ [`${field}_from`]: start, [`${field}_to`]: end },
    };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateList, 500);
    });
  };

  updateList = () => {
    const { page, searchQuery } = this.state;

    this.props.loadData(page, searchQuery);
  };

  render() {
    const { deleteClientUrls } = this;

    return (
      <main className="site--width clearfix container_statistics">
        <Toolbar
          toolsProps={{
            deleteClientUrls,
            count: this.props.count,
          }}
        />
        <div className="admin_user_table admin_table">
          <ClientUrlsList
            onOrderChange={this.onOrderChange}
            query={this.state.searchQuery}
            clientUrls={this.props.clientUrls}
            checkedClientUrlIds={this.checkedClientUrlIds}
            client_urls_ids={this.state.client_urls_ids}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    clientUrls: state.clientUrls.admin.list.values,
    count: state.clientUrls.admin.list.count,
    total_pages: state.clientUrls.admin.list.total_pages,
    page: state.clientUrls.admin.list.page,
    query: state.clientUrls.admin.list.query,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    deleteClientUrls: (client_urls_ids) =>
      dispatch(showDeleteClientUrlsConfirmationModal(client_urls_ids)),
    loadData: (page, query) => dispatch(loadClientUrlsSagaAdmin(page, query)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientUrls);



// WEBPACK FOOTER //
// ./src/containers/Admin/ClientUrls/ClientUrls.jsx